'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminTextesOfficielsController', ['$scope', '$http', '$timeout', 'Auth', function($scope, $http, $timeout, Auth) {

  var API        = '/api/textes-officiels';
  var UPLOAD_API = '/api/upload/pdf/textes-officiels';

  var rawItems  = [];
  var allItems  = [];
  $scope.textes         = [];
  $scope.categories     = [];
  $scope.isLoading      = true;
  $scope.showModal      = false;
  $scope.saving         = false;
  $scope.currentPage    = 1;
  $scope.itemsPerPage   = 10;
  $scope.pageSizeOptions = [10, 20, 50, 0];
  $scope.totalItems     = 0;
  $scope.totalPages     = 0;
  $scope.searchQuery    = '';
  $scope.filterCategory = '';
  $scope.editingTexte   = {};
  $scope.successMsg     = '';
  $scope.errorMsg       = '';
  $scope.uploadingPdf   = false;
  $scope.dropOver       = false;

  // ── Types (local) ─────────────────────────────────────────────────────────
  $scope.types = [
    { value: 'loi',         label: 'Loi' },
    { value: 'decret',      label: 'Décret' },
    { value: 'arrete',      label: 'Arrêté' },
    { value: 'ordonnance',  label: 'Ordonnance' },
    { value: 'reglement',   label: 'Règlement' },
    { value: 'circulaire',  label: 'Circulaire' },
    { value: 'instruction', label: 'Instruction' },
    { value: 'autre',       label: 'Autre' }
  ];
  $scope.showNewTypeForm = false;
  $scope.typeForm        = { label: '' };

  $scope.toggleNewTypeForm = function() {
    $scope.showNewTypeForm = !$scope.showNewTypeForm;
    $scope.typeForm.label  = '';
  };

  $scope.addType = function() {
    var label = ($scope.typeForm.label || '').trim();
    if (!label) { return; }
    var value = label.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    if (!$scope.types.some(function(t) { return t.value === value; })) {
      $scope.types.push({ value: value, label: label });
    }
    $scope.editingTexte.categoryCode = value;
    $scope.showNewTypeForm           = false;
    $scope.typeForm.label            = '';
  };

  // ── Nouvelle catégorie ────────────────────────────────────────────────────
  $scope.showNewCategoryForm = false;
  $scope.catForm             = { name: '' };
  $scope.savingCategory      = false;

  $scope.toggleNewCategoryForm = function() {
    $scope.showNewCategoryForm = !$scope.showNewCategoryForm;
    $scope.catForm.name        = '';
  };

  $scope.addCategory = function() {
    var name = ($scope.catForm.name || '').trim();
    if (!name) { return; }
    var code = name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    $scope.savingCategory = true;
    $http.post(API + '/categories', { code: code, name: name, description: name })
      .then(function(res) {
        var cat = res.data;
        var catId = cat.id != null ? String(cat.id) : code;
        if (!$scope.categories.some(function(c) { return String(c.id) === catId; })) {
          $scope.categories.push({ id: cat.id, name: cat.name || name });
        }
        $scope.editingTexte.categoryId   = cat.id;
        $scope.showNewCategoryForm       = false;
        $scope.catForm.name              = '';
        flash('successMsg', 'Catégorie "' + (cat.name || name) + '" créée.');
      })
      .catch(function(err) {
        flash('errorMsg', 'Erreur lors de la création de la catégorie (' + (err.status || '?') + ').');
      })
      .finally(function() { $scope.savingCategory = false; });
  };

  // ── Pagination ────────────────────────────────────────────────────────────
  function paginate() {
    var size = parseInt($scope.itemsPerPage, 10);
    if (!size) {
      $scope.textes     = allItems;
      $scope.totalPages = 1;
    } else {
      var start = ($scope.currentPage - 1) * size;
      $scope.textes     = allItems.slice(start, start + size);
      $scope.totalPages = Math.ceil(allItems.length / size) || 1;
    }
  }

  $scope.changePageSize = function() {
    $scope.currentPage = 1;
    paginate();
  };

  // ── Filtres ───────────────────────────────────────────────────────────────
  function applyFilters() {
    var q   = ($scope.searchQuery   || '').toLowerCase().trim();
    var cat = ($scope.filterCategory || '').trim();
    allItems = rawItems.filter(function(t) {
      var matchQ = !q || [
        t.title       || '',
        t.description || '',
        t.author      || ''
      ].some(function(f) { return f.toLowerCase().indexOf(q) !== -1; });
      var matchCat = !cat || String(t.categoryId) === cat;
      return matchQ && matchCat;
    });
    $scope.totalItems  = allItems.length;
    $scope.currentPage = 1;
    paginate();
  }

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  // ── Chargement ────────────────────────────────────────────────────────────
  $scope.loadTextes = function() {
    $scope.isLoading = true;
    $http.get(API)
      .then(function(res) {
        var data = res.data;
        rawItems = Array.isArray(data) ? data : (data.content || []);
        applyFilters();
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des textes officiels.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  function loadCategories() {
    $http.get(API + '/categories')
      .then(function(res) { $scope.categories = res.data || []; })
      .catch(angular.noop);
  }

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() { applyFilters(); }, 300);
  };

  $scope.onCategoryChange = function() { applyFilters(); };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p;
    paginate();
  };

  $scope.getPages = function() {
    var pages = [],
        start = Math.max(1, $scope.currentPage - 2),
        end   = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  // ── Upload PDF ────────────────────────────────────────────────────────────
  $scope.getPdfFilename = function(url) {
    if (!url) return '';
    var parts = url.split('/');
    var name  = parts[parts.length - 1];
    var idx   = name.indexOf('_');
    return idx >= 0 ? name.substring(idx + 1) : name;
  };

  function uploadFile(file) {
    if (!file) return;
    $scope.uploadingPdf = true;
    var formData = new FormData();
    formData.append('file', file);
    $http.post(UPLOAD_API, formData, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined }
    })
    .then(function(res) { $scope.editingTexte.fileUrl = res.data.url; })
    .catch(function(err) {
      var msg = (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'envoi du fichier.';
      flash('errorMsg', msg);
    })
    .finally(function() { $scope.uploadingPdf = false; });
  }

  $scope.triggerFileInput = function() {
    if ($scope.editingTexte.fileUrl) return;
    document.getElementById('texteOfficielPdfInput').click();
  };

  $scope.onFileSelected = function(input) {
    if (input.files && input.files[0]) {
      uploadFile(input.files[0]);
      input.value = '';
    }
  };

  $scope.handleDrop = function(event) {
    if ($scope.editingTexte.fileUrl || $scope.uploadingPdf) return;
    var files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length > 0) uploadFile(files[0]);
  };

  $scope.removePdf = function($event) {
    if ($event) { $event.preventDefault(); $event.stopPropagation(); }
    $scope.editingTexte.fileUrl = '';
  };

  // ── Formatage ─────────────────────────────────────────────────────────────
  $scope.formatDate = function(date) {
    if (!date) return '—';
    var d, day, month, year;
    if (Array.isArray(date)) {
      year = date[0]; month = date[1]; day = date[2];
    } else {
      d = new Date(date);
      if (isNaN(d.getTime())) return '—';
      day = d.getDate(); month = d.getMonth() + 1; year = d.getFullYear();
    }
    return (day < 10 ? '0' + day : '' + day) + '/' +
           (month < 10 ? '0' + month : '' + month) + '/' + year;
  };

  // ── Modal ─────────────────────────────────────────────────────────────────
  $scope.openModal = function(texte) {
    if (texte) {
      $scope.editingTexte = angular.copy(texte);
      var d = texte.date;
      if (Array.isArray(d)) {
        var y = d[0], m = d[1] < 10 ? '0' + d[1] : d[1], j = d[2] < 10 ? '0' + d[2] : d[2];
        $scope.editingTexte.dateStr = y + '-' + m + '-' + j;
      } else {
        $scope.editingTexte.dateStr = d ? d.substring(0, 10) : '';
      }
    } else {
      $scope.editingTexte = { dateStr: '' };
      Auth.identity().then(function(user) {
        if (user && !$scope.editingTexte.author) {
          $scope.editingTexte.author = (user.firstName || '') + (user.lastName ? ' ' + user.lastName : '');
        }
      });
    }
    $scope.uploadingPdf = false;
    $scope.dropOver     = false;
    $scope.showModal    = true;
  };

  $scope.closeModal = function() {
    $scope.showModal           = false;
    $scope.editingTexte        = {};
    $scope.uploadingPdf        = false;
    $scope.dropOver            = false;
    $scope.showNewCategoryForm = false;
    $scope.catForm.name        = '';
    $scope.showNewTypeForm     = false;
    $scope.typeForm.label      = '';
  };

  // ── Sauvegarde ────────────────────────────────────────────────────────────
  $scope.saveTexte = function() {
    if (!$scope.editingTexte.title) { flash('errorMsg', 'Le titre est obligatoire.'); return; }
    $scope.saving = true;
    var payload = {
      title:        $scope.editingTexte.title,
      description:  $scope.editingTexte.description,
      author:       $scope.editingTexte.author,
      fileUrl:      $scope.editingTexte.fileUrl || '',
      fileType:     $scope.editingTexte.fileType || 'PDF',
      categoryCode: $scope.editingTexte.categoryCode || '',
      categoryId:   $scope.editingTexte.categoryId   || null,
      date:         $scope.editingTexte.dateStr       || ''
    };
    var isEdit = !!$scope.editingTexte.id;
    var req = isEdit
      ? $http.put(API  + '/' + $scope.editingTexte.id, payload)
      : $http.post(API, payload);

    req.then(function() {
      $scope.closeModal();
      $scope.loadTextes();
      flash('successMsg', isEdit ? 'Texte officiel mis à jour.' : 'Texte officiel créé.');
    })
    .catch(function(err) {
      var msg = (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'enregistrement.';
      flash('errorMsg', msg);
    })
    .finally(function() { $scope.saving = false; });
  };

  // ── Suppression ───────────────────────────────────────────────────────────
  $scope.deleteTexte = function(texte) {
    if (!confirm('Supprimer "' + texte.title + '" ?')) return;
    $http.delete(API + '/' + texte.id)
      .then(function() { $scope.loadTextes(); flash('successMsg', 'Texte officiel supprimé.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  // ── Export ────────────────────────────────────────────────────────────────
  $scope.showExportMenu = false;
  $scope.toggleExportMenu = function($event) { $event.stopPropagation(); $scope.showExportMenu = !$scope.showExportMenu; };
  var _hideMenu = function() { $scope.$applyAsync(function() { $scope.showExportMenu = false; $scope.showColPicker = false; }); };
  document.addEventListener('click', _hideMenu);
  $scope.$on('$destroy', function() { document.removeEventListener('click', _hideMenu); });

  $scope.showColPicker = false;
  $scope.toggleColPicker = function($event) { $event.stopPropagation(); $scope.showColPicker = !$scope.showColPicker; $scope.showExportMenu = false; };
  $scope.col = { categorie: true, auteur: true, date: true, vues: true };
  var COL_DEFS = [
    { key: 'titre',     label: 'Titre',      fn: function(t){ return t.title||''; } },
    { key: 'categorie', label: 'Catégorie',   fn: function(t){ var n=''; $scope.categories.forEach(function(c){ if(String(c.id)===String(t.categoryId)){n=c.name;} }); return n; } },
    { key: 'auteur',    label: 'Auteur',     fn: function(t){ return t.author||''; } },
    { key: 'date',      label: 'Date',       fn: function(t){ return $scope.formatDate(t.date); } }
  ];
  function visibleDefs() { return COL_DEFS.filter(function(d){ return d.key === 'titre' || $scope.col[d.key]; }); }
  function getExportRows() {
    var defs = visibleDefs();
    return allItems.map(function(t) { return defs.map(function(d){ return d.fn(t); }); });
  }
  function getExportHeaders() { return visibleDefs().map(function(d){ return d.label; }); }
  function escHtml(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function triggerDl(blob, name) {
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); document.body.removeChild(a);
    $timeout(function() { URL.revokeObjectURL(url); }, 500);
  }
  $scope.exportCSV = function() {
    $scope.showExportMenu = false;
    var rows = getExportRows().map(function(r) { return r.map(function(v) { return '"'+String(v).replace(/"/g,'""')+'"'; }).join(';'); });
    triggerDl(new Blob(['\uFEFF'+getExportHeaders().join(';')+'\n'+rows.join('\n')], {type:'text/csv;charset=utf-8;'}), 'textes-officiels.csv');
  };
  $scope.exportExcel = function() {
    $scope.showExportMenu = false;
    var cell='border:1px solid #b0bec5;padding:6px 10px;font-size:11pt;font-family:Calibri,Arial,sans-serif;vertical-align:middle;', rows=getExportRows(), hdrs=getExportHeaders();
    var html='<html><head><meta charset="utf-8"/></head><body><table style="border-collapse:collapse">';
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#0f2544;color:#fff;font-size:14pt;font-weight:bold;text-align:center;padding:12px;">Textes Officiels</td></tr>';
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#e8edf5;color:#555;font-size:9pt;text-align:center;">Exporté le '+new Date().toLocaleDateString('fr-FR')+' — '+rows.length+' entrée(s)</td></tr>';
    html+='<tr>'+hdrs.map(function(h){return'<th style="'+cell+'background:#1e3a5f;color:#fff;font-weight:bold;">'+h+'</th>';}).join('')+'</tr>';
    rows.forEach(function(r,i){var bg=i%2===0?'#f0f4fa':'#fff';html+='<tr>'+r.map(function(v){return'<td style="'+cell+'background:'+bg+';">'+escHtml(v)+'</td>';}).join('')+'</tr>';});
    html+='</table></body></html>';
    triggerDl(new Blob(['\uFEFF'+html],{type:'application/vnd.ms-excel;charset=utf-8;'}), 'textes-officiels.xls');
  };

  // ── Init ──────────────────────────────────────────────────────────────────
  $scope.loadTextes();
  loadCategories();
}]);
